import type {DefineNumberFormat, I18nOptions} from "vue-i18n";


export default defineI18nConfig(
    () => ({
        defaultLocale: 'en',
        numberFormats: {
            fr: {
                currency: {
                    style: 'currency', currency: 'EUR', currencyDisplay: 'symbol',
                }
            } as DefineNumberFormat,
            en: {
                currency: {
                    style: 'currency', currency: 'USD', currencyDisplay: 'symbol',
                }
            } as DefineNumberFormat,
            de: {
                currency: {
                    style: 'currency', currency: 'EUR', currencyDisplay: 'symbol',
                }
            },
        }
    }) as I18nOptions)